import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchIntegratedAppCookieless } from './branches/BranchIntegratedAppCookieless';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchACQ151 } from './branches/BranchACQ151';
import { BranchACQ155Hublet } from './branches/BranchACQ155Hublet';
import { BranchCOAC0002 } from './branches/BranchCOAC0002';
import { BranchAddHublet } from './branches/BranchAddHubletStep';
import { BranchAddHubletStandaloneCmsPartner } from './branches/BranchAddHubletStandaloneCMSPartner';
const DefaultBranches = [BranchQuestionFallback];
let FlowBranches;
export const getFlowBranches = () => {
  if (typeof FlowBranches === 'undefined') {
    const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber];
    FlowBranches = {
      [Flow.Crm]: [...softwareSignupBranches, BranchACQ155Hublet, BranchCOAC0002, BranchAddHublet],
      [Flow.Marketing]: [...softwareSignupBranches, BranchACQ155Hublet, BranchCOAC0002, BranchAddHublet],
      [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchACQ155Hublet, BranchCOAC0002, BranchAddHublet],
      [Flow.Service]: [...softwareSignupBranches, BranchACQ155Hublet, BranchCOAC0002, BranchAddHublet],
      [Flow.CmsFree]: [BranchCmsBusinessMaturity, BranchACQ155Hublet, BranchAddHublet, ...softwareSignupBranches],
      [Flow.Integrations]: [BranchIntegratedAppCookieless, BranchACQ155Hublet, BranchAddHublet],
      [Flow.Purchase]: [BranchACQ151],
      [Flow.ClassroomTraining]: [BranchACQ155Hublet, BranchAddHublet],
      [Flow.AssetProvider]: [BranchACQ155Hublet, BranchAddHublet],
      [Flow.SolutionsProvider]: [BranchACQ155Hublet, BranchAddHublet],
      [Flow.FbCrm]: [BranchACQ155Hublet, BranchAddHublet],
      [Flow.HubspotForStartups]: [BranchACQ155Hublet, BranchAddHublet],
      [Flow.HubSpotPartners]: [BranchACQ155Hublet, BranchAddHublet],
      [Flow.StandaloneCmsPartner]: [BranchACQ155Hublet, BranchAddHubletStandaloneCmsPartner],
      [Flow.Microapp]: [BranchCmsBusinessMaturity, BranchACQ155Hublet, BranchAddHublet],
      [Flow.Commerce]: [BranchACQ155Hublet, BranchAddHublet]
    };
  }
  return FlowBranches[getFlowKey()] || DefaultBranches;
};